var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 29C58 45.0152 45.0153 58 29 58C12.9847 58 0 45.0152 0 29C0 12.9848 12.9847 0 29 0C45.0153 0 58 12.9848 58 29Z",
    fill: "#192643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.604 13.9459L27.2851 28.3211L21.3358 22.0351L18.1434 25.0272L27.1001 34.4955L45.6081 17.1281L42.604 13.9459Z",
    fill: "#00B0A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9342 12.9282C8.75229 19.2227 6.78941 30.6384 12.1037 39.1915L15.293 36.738C11.3051 29.9352 12.9189 21.0277 19.3557 16.0758C25.7925 11.1239 34.816 11.848 40.3688 17.4468L43.5581 14.9933C36.652 7.6648 25.1162 6.63375 16.9342 12.9282ZM14.5252 42.3391C17.2725 45.2561 20.758 47.1576 24.4685 48.0133L24.9939 44.0519C22.2985 43.3547 19.7678 41.956 17.7145 39.8856L14.5252 42.3391ZM44.9238 28.7978C44.9051 30.1275 44.7378 31.4541 44.3928 32.7391L48.092 34.2384C48.6616 32.3196 48.934 30.3227 48.915 28.3256L44.9238 28.7978ZM28.942 44.5523L28.4159 48.5191C31.7746 48.6133 35.1753 47.8714 38.274 46.2441L36.0637 42.9046C33.8081 44.0186 31.3679 44.5624 28.942 44.5523ZM42.8916 36.4287C42.0023 38.0071 40.8297 39.4601 39.3862 40.7009L41.5894 44.0311C43.711 42.3013 45.3702 40.2074 46.5829 37.9241L42.8916 36.4287Z",
    fill: "#00B0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.3b5ac7b3e899a15f6510cb8409ed790f.svg";
export { ForwardRef as ReactComponent };